import type { StandRow } from "../models/TrendDisplay";

// Stand names that the page hides regardless of which proxy branch is
// active (legacy or new). Mirrors the legacy IHBox stands.js module
// which filtered SHEAR + STRAIGHTENER stands client-side. Doing it by
// name (instead of by Type column) keeps the SP a true byte-by-byte port
// of the legacy: same shape, same row count, same columns. Both proxy
// branches return the full set of stands; this filter normalises the
// visible set in one place for chart, grid, and visualizer.
const HIDDEN_STAND_NAMES = new Set<string>(["S1", "StrtT", "StrtB"]);

export const filterVisibleStands = (stands: StandRow[]): StandRow[] =>
	stands.filter((s) => !HIDDEN_STAND_NAMES.has(s.Stand));
